import { useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Data
import featureCategories, {
  highlightAmenities,
  totalAmenityCount,
} from "pages/Home/sections/data/featuresData";

function Amenities() {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <MKBox component="section" py={6}>
      <Container>
        <MKTypography variant="h3" mb={1} textAlign="center">
          Amenities
        </MKTypography>
        <MKTypography variant="body2" color="text" textAlign="center" mb={4}>
          Everything you need for the perfect stay
        </MKTypography>
        <Grid container spacing={2} justifyContent="center">
          {highlightAmenities.map((item) => (
            <Grid item xs={6} sm={4} md={3} lg={2} key={item.label}>
              <MKBox
                textAlign="center"
                p={2}
                borderRadius="xl"
                sx={{
                  border: "1px solid",
                  borderColor: "grey.200",
                  height: "100%",
                }}
              >
                <Icon sx={{ fontSize: "2rem", color: "info.main", mb: 1 }}>{item.icon}</Icon>
                <MKTypography variant="body2" fontWeight="medium" color="dark">
                  {item.label}
                </MKTypography>
              </MKBox>
            </Grid>
          ))}
        </Grid>
        <MKBox textAlign="center" mt={4}>
          <MKButton variant="outlined" color="info" onClick={() => setDialogOpen(true)}>
            <Icon sx={{ mr: 1 }}>list</Icon>
            See All {totalAmenityCount} Amenities
          </MKButton>
        </MKBox>
      </Container>

      {/* Full amenities dialog */}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          <MKTypography variant="h5">All Amenities</MKTypography>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={4} justifyContent="center">
            {featureCategories.map((category) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={category.title}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <MKBox mb={2} sx={{ minWidth: 200 }}>
                  <MKBox display="flex" alignItems="center" mb={1.5}>
                    <Icon sx={{ color: "info.main", fontSize: "1.5rem", mr: 1 }}>
                      {category.icon}
                    </Icon>
                    <MKTypography variant="h6">{category.title}</MKTypography>
                  </MKBox>
                  {category.items.map((item) => (
                    <MKBox key={item.label} display="flex" alignItems="center" mb={0.8} pl={0.5}>
                      <Icon sx={{ color: "success.main", fontSize: "1rem", mr: 1, flexShrink: 0 }}>
                        {item.icon}
                      </Icon>
                      <MKTypography variant="body2" color="dark">
                        {item.label}
                      </MKTypography>
                    </MKBox>
                  ))}
                </MKBox>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <MKButton variant="gradient" color="info" onClick={() => setDialogOpen(false)}>
            Close
          </MKButton>
        </DialogActions>
      </Dialog>
    </MKBox>
  );
}

export default Amenities;
